
import { Button } from "@/components/ui/button";
import { CartItem } from "@/contexts/CartContext";
import { format, parseISO } from "date-fns";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Info } from "lucide-react";

interface CheckoutSummaryProps {
  items: CartItem[];
  total: number;
  deliveryFee: number;
  finalTotal: number;
  deliveryType: "delivery" | "pickup";
  processingFee: number; // Added processing fee
}

export const CheckoutSummary = ({
  items,
  total,
  deliveryFee,
  finalTotal,
  deliveryType,
  processingFee, // Added processing fee
}: CheckoutSummaryProps) => {
  return (
    <div className="bg-card rounded-lg p-6">
      <h2 className="text-xl font-semibold mb-4">Order Summary</h2>
      {items.map((item) => (
        <div key={item.id} className="mb-4">
          <div className="flex justify-between items-center mb-2">
            <span>{item.quantity}x {item.name}</span>
            <span>${(item.price * item.quantity).toFixed(2)}</span>
          </div>
          {item.scheduledDate && (
            <p className="text-sm text-muted-foreground">
              Scheduled for: {format(parseISO(item.scheduledDate), "EEEE, MMMM d, yyyy")}
            </p>
          )}
        </div>
      ))}
      <div className="border-t mt-4 pt-4">
        <div className="flex justify-between mb-2">
          <span>Subtotal</span>
          <span>${total.toFixed(2)}</span>
        </div>
        {deliveryType === "delivery" && (
          <div className="flex justify-between mb-2">
            <span>Delivery Fee</span>
            <span>${deliveryFee.toFixed(2)}</span>
          </div>
        )}
        <div className="flex justify-between mb-2">
          <span className="flex items-center">
            Processing fee
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <span className="ml-1 cursor-help">
                    <Info size={14} />
                  </span>
                </TooltipTrigger>
                <TooltipContent>
                  <p className="w-[200px] text-xs">
                    This covers payment processing costs (2.9% + $0.30)
                  </p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </span>
          <span>${processingFee.toFixed(2)}</span>
        </div>
        <div className="flex justify-between font-semibold">
          <span>Total</span>
          <span>${finalTotal.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};
